import { render, staticRenderFns } from "./ChannelManager.vue?vue&type=template&id=42d16c09&lang=pug"
import script from "./ChannelManager.vue?vue&type=script&lang=js"
export * from "./ChannelManager.vue?vue&type=script&lang=js"
import style0 from "./ChannelManager.vue?vue&type=style&index=0&id=42d16c09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports